/* eslint-disable no-use-before-define */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
import { Button, Divider, Grid, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';

const options = [
  { value: 'Select Disposition', label: 'Select Disposition' },
  { value: 'Scrap item', label: 'Scrap item' },
  { value: 'Ship back to customer', label: 'Ship back to customer' },
  // { value: "Transfer to Skokie", label: "Transfer to Skokie" },
];
const options2 = [
  { value: 'Select Action', label: 'Select Action' },
  // { value: 'Approved', label: 'Approved-New RGA' },
  { value: 'Rejected', label: 'Rejected' },
];
const UnauthTransactionId = () => {
  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  // const [rgaAll, setRgaAll] = useState([]);
  const [dropValue, setDropValue] = useState(options[0]);
  const [dropValue2, setDropValue2] = useState(options2[0]);
  const [imageLoadError, setImageLoadError] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const { control, handleSubmit, setValue } = useForm();
  const handleImageError = (index) => {
    setImageLoadError((prevErrors) => [...prevErrors, index]);
  };
  const allImagesFailed = imageLoadError.length === images.length;

  const handleDropChange = (selectedOption) => {
    setDropValue2('');
    setSearchValue('');
    setDropValue(selectedOption || null);
  };
  const handleDropChange2 = (selectedOption) => {
    setDropValue2(selectedOption || null);
  };

  const openImageInNewTab = (imageName, width, height) => {
    const imageUrl = variables.IMAGE_URL + imageName;
    const newWindow = window.open('', '_blank');
    newWindow.document.write(
      `<html><head><title>${imageName}</title></head><body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh;"><img src="${imageUrl}" alt="${imageName}" style="max-width: 100%; max-height: 100%;"></body></html>`,
    );
    newWindow.resizeTo(width, height);
    newWindow.focus();
  };
  const openAllImagesInNewTab = () => {
    const myobje = JSON.parse(localStorage.getItem('TransactionId_id')) || {};
    const newTab = window.open();
    newTab.document.write('<html><body>');

    //     images.forEach((image) => {
    //       const matchingObject = rgaAll.find((obj) => obj.ImagePath.includes(image));
    //       console.log(matchingObject);
    //       if (matchingObject) {
    //         const { Item, RGA, idx } = matchingObject;
    //         newTab.document.write(
    //           `<div style='text-align: center;'>
    //             <p>Transaction Id: ${idx} | RGA: ${RGA} | Item: ${Item}</p>
    //             <img src="${
    //   variables.IMAGE_URL + image
    // }" alt="Not available" style="border: 1px solid black; width: 100%; margin: 15px 0px; border-radius: 15px;" />
    //           </div>`,
    //         );
    //       }
    //     });
    images.forEach((image) => {
      newTab.document.write(
        `<p style='text-align: center;'>  Transaction Id: ${myobje.IDX} | RMA: ${myobje.RMA} | Tracking No: ${
          myobje.TrackingNumber
        }</p><img src="${
          variables.IMAGE_URL + image
        }" alt="Not available" style="border: 1px solid black; width: 100%; margin: 15px 0px; border-radius: 15px;"  />`,
      );
    });
    newTab.document.write('</body></html>');
    newTab.document.close();
  };

  const imageAPi = async () => {
    setLoading(true);
    const myobje = JSON.parse(localStorage.getItem('TransactionId_id')) || {};
    try {
      const response = await axios.post(`${variables.BASE_URL}TransactionID`, {
        ID: myobje.IDX || '',
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'UnAuthorized List',
      });
      if (response.data.IsSuccess) {
        const imageString = response.data?.TransactionID[0]?.ImagePath || '';
        const imageArray = imageString.split(';').filter(Boolean);
        // setRgaAll(response.data.CoreItem);
        setImages(imageArray);
      } else {
        const imageString = response.data?.TransactionID[0]?.ImagePath || '';
        const imageArray = imageString.split(';').filter(Boolean);
        setImages(imageArray);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    } finally {
      setLoading(false);
    }
  };

  const fieldNames = [
    'Transaction Id',
    'RMA#',
    'createddate',
    'Tracking Number',
    'CallerID',
    'Cust_Address1',
    'Cust_Address2',
    'Cust_City',
    'Cust_Country',
    'Cust_Country',
    'Cust_Name',
    'Cust_State',
    'Cust_ZipCode',
    'Receiving Notes',
    'Comment',
  ];
  const setValuesFromLocalStorage = () => {
    const storedValue = JSON.parse(localStorage.getItem('TransactionId_id')) || {};
    fieldNames.forEach((fieldName) => {
      const keyMappings = {
        IDX: 'Transaction Id',
        RMA: 'RMA#',
        Vendor: 'Vendor',
        createddate: 'createddate',
        TrackingNumber: 'Tracking Number',
        CallerID: 'CallerID',
        Cust_Address1: 'Cust_Address1',
        Cust_Address2: 'Cust_Address2',
        Cust_City: 'Cust_City',
        Cust_Country: 'Cust_Country',
        Cust_Name: 'Cust_Name',
        Cust_State: 'Cust_State',
        Cust_ZipCode: 'Cust_ZipCode',
        Notes: 'Receiving Notes',
        Comment: 'Comment',
      };

      const renamedObject = Object.fromEntries(
        Object.entries(storedValue).map(([key, value]) => [
          keyMappings[key] || key,
          value,
        ]),
      );

      if (renamedObject && renamedObject.hasOwnProperty(fieldName)) {
        setValue(fieldName, renamedObject[fieldName]);
      }
    });
    const defaultOption = options2[0];
    setDropValue(defaultOption);
    setDropValue2(options[0]);
    // if (defaultOption.value === 'Rejected') {
    //   const defaultOption2 = storedValue.Disposition === 'Scrap item'
    //     ? options[1]
    //     : storedValue.Disposition === 'Ship back to customer'
    //       ? options[2]
    //       : storedValue.Disposition === 'Transfer to Skokie'
    //         ? options[3]
    //         : options[0];
    //   setDropValue2(defaultOption2);
    // }
    imageAPi();
  };
  const checkRaNo = async () => {
    const isValid = /^R\d{9}$/.test(searchValue);
    if (searchValue !== '') {
      if (!isValid) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: "RA Number must start with 'R' followed by 9 digits.",
        }).then((result) => {
          if (result.isConfirmed) {
            setSearchValue('');
            setTimeout(() => {
              document.getElementById('RaNo_Id').focus();
            }, 300);
          }
        });
      }
      setLoading(true);
      try {
        const response = await axios.post(
          `${variables.BASE_URL}ValidateRA`,
          { RA: searchValue.trim() },
        );
        if (!response.data.IsSuccess) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data.Reason,
          }).then((result) => {
            if (result.isConfirmed) {
              setSearchValue('');
              setTimeout(() => {
                document.getElementById('RaNo_Id').focus();
              }, 300);
            }
          });
        }
      } catch (error) {
        console.error('An error occurred:', error);
      } finally {
        setLoading(false);
      }
    }
  };
  const cancelAll = () => {
    setValue('Comment', '');
    setShow(false);
    localStorage.removeItem('TransactionId_id');
    setImages([]);
    setDropValue('');
    setDropValue2('');
    setSearchValue('');
    setImageLoadError([]);
    document.getElementById('getUnauthData_id').click();
  };
  const onSubmit = (data) => {
    console.log(data);
    SaveTransaction(data);
  };

  const SaveTransaction = async (param) => {
    if (dropValue.value !== 'Select Action') {
      setLoading(true);
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'UnAuthorized List',
        ID: param['Transaction Id'] || '',
        ActionType: dropValue.value || '',
        DISP: dropValue2.value || '',
        Comment: param.Comment?.trim() || '',
      };
      try {
        const response = await axios.post(
          `${variables.BASE_URL}SaveUnAuthData`,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        const Data = response.data;
        if (Data.IsSuccess) {
          console.log(Data.IsSuccess);
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: Data.Reason,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              cancelAll();
            }
          });
        } else if (!Data.IsSuccess) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: Data.Reason,
            allowOutsideClick: false,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          allowOutsideClick: false,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const saveEnable = (dropValue.value === 'Rejected' && (dropValue2.value === 'Scrap item' || dropValue2.value === 'Ship back to customer'))
  || dropValue.value === 'Approved';

  const saveDisable = !saveEnable;
  return (
    <>
      <Button
        sx={{ display: 'none' }}
        variant="primary"
        onClick={() => {
          setValuesFromLocalStorage();
          setTimeout(() => {
            setShow(true);
          }, 100);
        }}
        id="TransactionId_id"
      >
        Custom Width Modal
      </Button>

      <Modal
        show={show}
        backdrop="static"
        onHide={() => {
          setShow(false);
          localStorage.removeItem('TransactionId_id');
          setImages([]);
          setImageLoadError([]);
          setValue('Comment', '');
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title" className="fw-bold">
            Transaction Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '85vh', overflow: 'auto' }}>
          <div style={{ padding: '20px' }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                {fieldNames.slice(0, 13).map((fieldName, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Controller
                      name={fieldName}
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label={
                            fieldName.charAt(0).toUpperCase()
                            + fieldName.slice(1)
                          }
                          variant="outlined"
                          fullWidth
                          disabled
                          InputProps={{
                            readOnly: true,
                          }}
                          {...field}
                        />
                      )}
                    />
                  </Grid>
                ))}
                {fieldNames.slice(13, 14).map((fieldName, index) => (
                  <Grid item xs={12} sm={6} md={9} key={index}>
                    <Controller
                      name={fieldName}
                      control={control}
                      defaultValue=""
                      render={({ field }) => {
                        const value = field.value || '';
                        const len = value.length;
                        // dynamically determine rows based on length
                        const rows = len <= 200 ? 2 : 3;
                        return (
                          <TextField
                            size="small"
                            label={
                                    fieldName.charAt(0).toUpperCase()
                                    + fieldName.slice(1)
                                  }
                            variant="outlined"
                            fullWidth
                            disabled
                            multiline
                            rows={rows}
                            InputProps={{
                              readOnly: true,
                              style: {
                                whiteSpace: 'pre-wrap', // keeps line breaks
                                wordBreak: 'break-word', // prevents overflow
                              },
                            }}
                            {...field}
                          />
                        );
                      }}
                    />
                  </Grid>
                ))}
              </Grid>

              <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                <Grid item xs={8} sm={4} md={3}>
                  <div id="ItemType_id">
                    <Select
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          height: '40px',
                          minWidth: '200px',
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          fontWeight: 550, // make text bold
                          fontSize: '16px', // make selected value slightly bigger
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          fontWeight: 550, // bold text for dropdown items
                          fontSize: '16px', // bigger text for dropdown items
                          backgroundColor: state.isFocused ? '#e5e7eb' : 'white', // optional hover color
                          color: '#000',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          fontSize: '16px', // also increase placeholder size
                          fontWeight: 550,
                        }),
                      }}
                      id="ActionType"
                      name="ActionType"
                      defaultValue={dropValue}
                      onChange={handleDropChange}
                      options={options2}
                      placeholder="Action Type"
                    />
                  </div>
                </Grid>
                {!localStorage.getItem('TransactionId_id') ? null
                  : dropValue.value === 'Rejected'
                    ? (
                      <Grid item xs={12} sm={6} md={3}>
                        <div id="ItemType_id">
                          <Select
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                height: '40px',
                                minWidth: '200px',
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                fontWeight: 550, // bold selected text
                                fontSize: '16px', // slightly larger text
                                color: '#000', // ensure consistent color
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                fontWeight: 550, // bold options text
                                fontSize: '16px', // larger dropdown text
                                backgroundColor: state.isFocused ? '#e5e7eb' : 'white', // hover background
                                color: '#000',
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontSize: '16px', // increase placeholder size
                                fontWeight: 550, // make placeholder bold
                                color: '#000', // set dark color to look bold
                                opacity: 1, // remove faded look
                              }),
                            }}
                            id="disposition"
                            name="disposition"
                            defaultValue={dropValue2}
                            onChange={handleDropChange2}
                            options={options}
                            placeholder="Select Disposition"
                          />

                        </div>
                      </Grid>
                    ) : dropValue.value === 'Approved'
                      ? (
                        <Grid item xs={12} sm={6} md={3}>
                          <div>
                            <TextField
                              autoComplete="off"
                              id="RaNo_Id"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value.toUpperCase().trim())}
                              label="New RGA"
                              style={{ height: '40px', width: '200px', display: 'none' }}
                              outline
                              size="small"
                              onBlur={checkRaNo}
                            />
                          </div>
                        </Grid>
                      ) : null}
                {fieldNames.slice(14, 15).map((fieldName, index) => (
                  <Grid item xs={12} sm={6} md={6} key={index}>
                    <Controller
                      name={fieldName}
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label={fieldName === 'Comment' ? 'Customer Remark' : (fieldName.charAt(0).toUpperCase() + fieldName.slice(1))}
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          multiline
                          rows={2}
                          placeholder={fieldName === 'Comment' ? 'Customer Remark' : fieldName}
                          {...field}
                        />
                      )}
                    />
                  </Grid>
                ))}
              </Grid>
              {loading ? (
                <LoadingOverlay />
              ) : (
                <Grid container spacing={2} sx={{ justifyContent: 'flex-end', marginTop: '5px' }}>
                  {JSON.parse(localStorage.getItem('TransactionId_id')) ? (
                    <Grid item xs={4} sm={2} md={1}>
                      <Button
                        type="submit"
                        style={{
                          background: saveDisable ? '#e0e0e0' : '#2563eb', // muted gray vs blue
                          color: saveDisable ? '#9ca3af' : '#ffffff',
                          borderRadius: '10px',
                          padding: '8px 20px',
                          fontWeight: 600,
                          border: 'none',
                          textTransform: 'none',
                          cursor: saveDisable ? 'not-allowed' : 'pointer',
                          boxShadow: saveDisable
                            ? 'inset 2px 2px 5px #c1c1c1, inset -2px -2px 5px #ffffff' // soft inset for disabled
                            : '6px 6px 12px #d1d9e6, -6px -6px 12px #ffffff', // raised for active
                          transition: 'all 0.3s ease',
                        }}
                        disabled={saveDisable}
                        onMouseEnter={(e) => {
                          if (!saveDisable) e.currentTarget.style.background = '#1d4ed8'; // darker blue hover
                        }}
                        onMouseLeave={(e) => {
                          if (!saveDisable) e.currentTarget.style.background = '#2563eb';
                        }}
                      >
                        Save
                      </Button>
                    </Grid>
                  ) : null}
                  <Grid item xs={4} sm={2} md={1}>
                    <Button
                      onClick={cancelAll}
                      style={{
                        background: '#dc2626',
                        color: '#f8f9fa', // soft red
                        borderRadius: '10px',
                        padding: '8px 20px',
                        fontWeight: 600,
                        border: 'none',
                        textTransform: 'none',
                        cursor: 'pointer',
                        boxShadow: '6px 6px 12px #d1d9e6, -6px -6px 12px #ffffff',
                        marginLeft: '12px',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              )}
            </form>
            <Divider style={{ marginTop: '10px' }} />
            <div>
              {images.length !== 0 ? (
                <>
                  {/* <Typography variant="h4">Images</Typography> */}
                  {!allImagesFailed && (
                    <div>
                      <Button
                        variant="outlined"
                        onClick={openAllImagesInNewTab}
                      >
                        View Full Image
                      </Button>
                    </div>
                  )}
                  <div
                    style={{
                      height: '400px',
                      overflowY: 'auto',
                      marginTop: '10px',
                    }}
                  >
                    {!allImagesFailed
                      && images.map((image, index) => (
                        <button
                          key={index}
                          onClick={() => openImageInNewTab(image, 800, 600)}
                          style={{
                            cursor: 'pointer',
                            margin: '5px',
                            borderRadius: '5px',
                          }}
                        >
                          <img
                            src={variables.IMAGE_URL + image}
                            alt="Not available"
                            // alt={image}
                            style={{ width: '200px', height: '200px' }}
                            loading="lazy" // Set loading attribute to "lazy"
                            onError={() => handleImageError(index)}
                          />
                        </button>
                      ))}

                    {allImagesFailed && (
                      <div>
                        <Typography variant="h6">
                          Images are not available for given item
                        </Typography>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <Typography variant="h6">
                  Images are not available for given item
                </Typography>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UnauthTransactionId;
